import {
  Money,
  Promotion,
  PromotionApplication,
  PromotionStatus,
  PromotionType,
} from '@rediredi/types'

export const useDiscountStore = defineStore('discount', {
  state: (): {
    coupon: Promotion | null
  } => {
    return {
      coupon: null,
    }
  },

  actions: {
    setCoupon(coupon: Promotion | null) {
      const { discountStorage } = useDiscountStorage()

      this.coupon = coupon
      discountStorage.value.code = coupon?.code || ''
    },

    removeCoupon() {
      const { discountStorage } = useDiscountStorage()

      this.coupon = null
      discountStorage.value.code = ''
    },

    isPromoValid(promotion?: Promotion) {
      if (!promotion) return false

      if (promotion.status !== PromotionStatus.Active) return false

      if (!promotion.applications?.includes(PromotionApplication.OrderCoupon)) return false

      if (
        ![PromotionType.Discount, PromotionType.FreeShipping, PromotionType.SellingPrice].includes(
          promotion.type!,
        )
      )
        return false

      if (promotion.endsAt && new Date(promotion.endsAt) < new Date()) return false

      return true
    },

    async applyCoupon(code: string) {
      const { discountStorage } = useDiscountStorage()
      const checkoutStore = useCheckoutStore()
      const promotion = await useFetchWrapper<Promotion>(
        `/promotions/storefront/promotions/${code}`,
        'GET',
      )

      if (this.isPromoValid(promotion)) {
        this.setCoupon(promotion)
        checkoutStore.coupon.code = promotion.code!
        checkoutStore.coupon.isApplied = true
        return true
      } else {
        discountStorage.value.code = ''
      }
    },

    getDiscountedPrice(price: Money, isTotal = false): Money {
      if (!this.coupon || !price) return price

      if (this.coupon.type === PromotionType.FreeShipping) return price

      if (!isTotal && this.coupon.type === PromotionType.SellingPrice) return price

      if (isTotal && this.coupon.type === PromotionType.SellingPrice) {
        const discountedAmount = price.amount - (this.coupon.promotionPrice?.amount ?? 0)

        return {
          ...price,
          amount: discountedAmount < 0 ? 0 : discountedAmount,
        }
      }

      const discountedAmount =
        price.amount - (this.coupon.promotionPercent ?? 0) * price.amount * 0.01

      return {
        ...price,
        amount: discountedAmount < 0 ? 0 : discountedAmount,
      }
    },
  },
})
